module.exports = __webpack_public_path__ + "img/modalTopArrow.0ff281db.svg";